/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2025-01-02 09:54:28
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-07-02 21:35:04
 * @FilePath: /isp_International/src/i18n/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD置
 */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { getLangVersion } from '@/api/newApi/lang';
import { setLocal, getLocal, removeLocal, LocalNameEnum } from '@/util/storage';
import moment from 'moment';

// -- multiple langs TODO --
const supportLangs = ['vi', 'en', 'zh', 'hu', 'th', 'ms', 'pt-BR', 'zh_Hant', 'id', 'ru', 'de'];
const momentLocaleLoaders: Record<string, () => Promise<unknown>> = {
  vi: () => import('moment/locale/vi'),
  en: () => import('moment/locale/en-gb'),
  zh: () => import('moment/locale/zh-cn'),
  hu: () => import('moment/locale/hu'),
  th: () => import('moment/locale/th'),
  ms: () => import('moment/locale/ms'),
  'pt-BR': () => import('moment/locale/pt-br'),
  zh_Hant: () => import('moment/locale/zh-hk'),
  id: () => import('moment/locale/id'),
  ru: () => import('moment/locale/ru'),
  de: () => import('moment/locale/de'),
};
const momentLangs: Record<string, string> = {
  vi: 'vi',
  en: 'en-gb',
  zh: 'zh-cn',
  hu: 'hu',
  th: 'th',
  ms: 'ms',
  'pt-BR': 'pt-br',
  zh_Hant: 'zh-hk',
  id: 'id',
  ru: 'ru',
  de: 'de',
};

let bootstrapDone = false;
let languageChangedHooked = false;

const syncDocumentLanguage = (langCode: string) => {
  if (typeof document === 'undefined') return;

  document.documentElement.lang = langCode;
  document.documentElement.setAttribute('data-lang', langCode);
};

const applyMomentLocale = (langCode: string) => {
  const momentLocale = momentLangs[langCode];
  if (!momentLocale) {
    return;
  }

  const loader = momentLocaleLoaders[langCode];
  if (loader) {
    void loader().then(() => {
      moment.locale(momentLocale);
    });
    return;
  }

  moment.locale(momentLocale);
};

function getBaseLanguage() {
  const language = navigator.language;
  const locale = new Intl.Locale(language);
  return locale.language;
}

export const resolveLangCode = (): string => {
  const currentSelectLangCode = localStorage.getItem('_language');
  const browserDefaultLang = getBaseLanguage();
  return currentSelectLangCode || (supportLangs.includes(browserDefaultLang) && browserDefaultLang) || 'zh';
};

/** 同步初始化 i18n（空词条），不阻塞首屏；TLT 在远程包到达前回退展示原文 */
export const bootstrapI18nSync = (): string => {
  const langCode = resolveLangCode();
  setLocal(LocalNameEnum.mulLangLocalTagRemark, langCode);
  syncDocumentLanguage(langCode);
  applyMomentLocale(langCode);

  if (!bootstrapDone) {
    i18n.use(initReactI18next).use(LanguageDetector).init({
      resources: {
        [langCode]: { translation: {} },
      },
      lng: langCode,
      interpolation: {
        escapeValue: false,
      },
      initImmediate: false,
    });

    if (!languageChangedHooked) {
      i18n.on('languageChanged', syncDocumentLanguage);
      languageChangedHooked = true;
    }
    bootstrapDone = true;
  } else if (i18n.language !== langCode) {
    i18n.changeLanguage(langCode);
  }

  return langCode;
};

// 语言包本地缓存：命中即可用缓存词条同步挂载首屏，省去启动期两段跨境请求
// （getLangVersion + fetch 词条）的串行 RTT；仅缓存「当前选中语言」一份。
const LANG_PACK_CACHE_PREFIX = '_wisp_lang_pack_v2_';
const LANG_PLACEHOLDER_PATTERN = /\$\{lang\}|\$%7Blang%7D|%24%7Blang%7D/i;
const LANG_RESOURCE_FETCH_TIMEOUT = 12000;

const readCachedLangPack = (langCode: string): Record<string, unknown> | null => {
  try {
    const raw = localStorage.getItem(LANG_PACK_CACHE_PREFIX + langCode);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const writeCachedLangPack = (langCode: string, langResult: Record<string, unknown>) => {
  try {
    localStorage.setItem(LANG_PACK_CACHE_PREFIX + langCode, JSON.stringify(langResult));
  } catch (e) {
    // QuotaExceededError 等：词条包超出 localStorage 配额或空间已满，
    // 静默放弃缓存，下次启动仍走远程拉取（不影响功能，仅失去本次提速）
  }
};

const buildLangDataUrl = (template: string, langCode: string): string => {
  const normalizedLang = langCode.replace(/-/g, '_');
  return template
    .replace(/\$\{lang\}/g, normalizedLang)
    .replace(/\$%7Blang%7D/gi, normalizedLang)
    .replace(/%24%7Blang%7D/gi, normalizedLang);
};

const fetchLangPackWithTimeout = async (url: string): Promise<Record<string, unknown> | null> => {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), LANG_RESOURCE_FETCH_TIMEOUT);

  try {
    const result = await fetch(url, { signal: controller.signal });
    if (!result.ok) {
      return null;
    }

    const langResult = await result.json();
    return langResult && typeof langResult === 'object' ? langResult : null;
  } finally {
    window.clearTimeout(timer);
  }
};

const getValidCachedLangRemarkTemplate = (): string => {
  const cachedTemplate = getLocal(LocalNameEnum.langRemark);
  if (typeof cachedTemplate !== 'string' || !cachedTemplate) {
    return '';
  }

  if (LANG_PLACEHOLDER_PATTERN.test(cachedTemplate)) {
    return cachedTemplate;
  }

  // 旧版本误把已替换语言的具体 URL 写入 langRemark；国外接口失败时复用会拉错语言包，
  // 因此遇到无占位符的历史缓存直接清理，避免把中文包继续写入其它语言缓存。
  removeLocal(LocalNameEnum.langRemark);
  return '';
};

const mergeRemoteTranslations = (langCode: string, langResult: Record<string, unknown>) => {
  const existing = i18n.getResourceBundle(langCode, 'translation') || {};
  i18n.addResourceBundle(langCode, 'translation', { ...existing, ...langResult }, true, true);
  applyMomentLocale(langCode);
  // 触发 react-i18next / 依赖 language 的组件刷新，避免 remount 整个 Router
  void i18n.changeLanguage(langCode);
};

/** 拉取远程语言包并合并；启动期会等待该 Promise 完成后再挂载 React。 */
export const loadRemoteI18nResources = async (langCode: string = resolveLangCode()): Promise<void> => {
  let langInfo: any = {};
  try {
    langInfo = await getLangVersion({
      tag: 'tagWisp',
    });
  } catch (e) {
    console.error(e);
  }

  let langDataUrl = '';
  const remoteRemarkTemplate = langInfo?.success && langInfo.value?.length ? langInfo.value[0].remark : '';
  const remarkTemplate = remoteRemarkTemplate || getValidCachedLangRemarkTemplate();

  if (remarkTemplate) {
    langDataUrl = buildLangDataUrl(remarkTemplate, langCode);
    if (remoteRemarkTemplate && LANG_PLACEHOLDER_PATTERN.test(remoteRemarkTemplate)) {
      // 本地只缓存带 ${lang} 的模板，不能缓存已替换后的具体 URL；否则国外网络兜底时会跨语言拉错包。
      setLocal(LocalNameEnum.langRemark, remoteRemarkTemplate);
    }
  }

  if (!langDataUrl) {
    return;
  }

  try {
    const langResult = await fetchLangPackWithTimeout(langDataUrl);
    if (langResult) {
      // 写本地缓存供下次启动同步渲染；再合并到 i18n 刷新当前页面
      writeCachedLangPack(langCode, langResult);
      mergeRemoteTranslations(langCode, langResult);
    }
  } catch (e) {
    console.error(e);
  }
};

export const bootstrapI18n = async (): Promise<string> => {
  const langCode = bootstrapI18nSync();

  // 缓存优先：命中本地缓存则先用缓存词条同步挂载首屏，远程词条后台刷新，
  // 关键路径不再串行等待 getLangVersion + fetch 两段跨境请求（泰国等高 RTT 收益明显）。
  const cached = readCachedLangPack(langCode);
  if (cached) {
    mergeRemoteTranslations(langCode, cached);
    void loadRemoteI18nResources(langCode);
    return langCode;
  }

  // 首次访问无缓存：仍等远程词条合并后再挂载，避免首屏未翻译闪烁；同时写入缓存供下次提速。
  await loadRemoteI18nResources(langCode);
  return langCode;
};

/** @deprecated 兼容旧调用；远程语言包就绪后再执行 callback，避免首屏使用空词条渲染。 */
const initI18n = async (callback: () => void) => {
  await bootstrapI18n();
  callback();
};

export default initI18n;
